import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useAuth0 } from "@auth0/auth0-react";
import classNames from "classnames";
import Modal from 'react-bootstrap/Modal';
import apiClient from './services/apiClient.js'
import packageJson from '../package.json';
import UserProfile from './auth/UserProfile.jsx';
import AlertModal from './AlertModal.jsx';

import { 
    setIsAutoScan
 } from './redux/autoScanSlice.js'

import { 
    setShowVehicle,
    setSelectedVehicle,
    setSelectedVehicleHistory,
 } from './redux/vehicleSlice.js'

 const Header = () => {

   const [modalShow, setModalShow] = useState(false);
   const [settingsModalShow, setSettingsModalShow] = useState(false);
   const [logoutModalShow, setLogoutModalShow] = useState(false);
   const [plateToSearch, setPlateToSearch] = useState(null);
   const [proModeUnlocked, setProModeUnlocked] = useState(() => {
       return localStorage.getItem('proModeUnlocked') === 'true';
   });
 //    const plateToSearchRef = React.useRef(plateToSearch);
   const [isLoading, _setIsLoading] = useState(false);
   const isLoadingRef = React.useRef(isLoading);
   const { user, isAuthenticated, getAccessTokenSilently, logout } = useAuth0();
   const isAutoScan = useSelector((state) => state.autoScan.isAutoScan);
   const dispatch = useDispatch()
   const isFullScreen = () => ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen));
   
   // Settings state - stored in localStorage
   const [soundEnabled, setSoundEnabled] = useState(() => {
       const saved = localStorage.getItem('driveOffSoundEnabled');
       return saved !== null ? JSON.parse(saved) : true; // Default: enabled
   });

   const [allVehicleSoundEnabled, setAllVehicleSoundEnabled] = useState(() => {
       const saved = localStorage.getItem('allVehicleSoundEnabled');
       return saved !== null ? JSON.parse(saved) : false; // Default: disabled
   });
   

   const setIsLoading = data => {
    isLoadingRef.current = data;
    _setIsLoading(data);
 };

   const onLogoutModalClick = () => {
        setLogoutModalShow(false);
        logout({ logoutParams: { returnTo: window.location.origin } });
   }

   const loadAutoScanStatusAsync = async () => {

    if (!isAuthenticated) {
        return;
     }

     
     if(user['/roles'].length === 0)
     {
      setIsLoading(false);
      setLogoutModalShow(true);
      return;
     }


    const accessToken = await getAccessTokenSilently({
        authorizationParams: {
                audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
            }
        });
   const userRole = user['/roles'][0];
    const params = {
        serviceStationOwnerId: "Shan", //Read from user object maybe or config if we decide to have a site per customer, (subweb)
        groupName: userRole
    };

    const result = await apiClient.getAutoScansettingForServoAsync(params, accessToken)
    dispatch(setIsAutoScan(result.isAutoScanEnabled));
 }
   useEffect(() => {
      loadAutoScanStatusAsync();
   }, [isAuthenticated]);


   const onSearchForRegoChange = (event) => {
    const value = event.target.value;
    setPlateToSearch(value);
    
    // Check for Pro Mode secret code
    if (value.toLowerCase() === 'pro mode') {
        setProModeUnlocked(true);
        localStorage.setItem('proModeUnlocked', 'true');
        setPlateToSearch(''); // Clear the input
        
        // Show success notification
        const notification = document.createElement('div');
        notification.style.cssText = `
            position: fixed;
            top: 80px;
            right: 20px;
            background: linear-gradient(135deg, #1E70E0 0%, #0D47A1 100%);
            color: white;
            padding: 1rem 1.5rem;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            z-index: 10000;
            font-weight: 500;
            animation: slideIn 0.3s ease-out;
        `;
        notification.innerHTML = '✓ Pro Mode Activated - Advanced Features Enabled';
        document.body.appendChild(notification);
        
        setTimeout(() => {
            notification.style.animation = 'slideOut 0.3s ease-out';
            setTimeout(() => notification.remove(), 300);
        }, 3000);
    }
    
    // Check for Standard Mode secret code (to disable Pro Mode)
    if (value.toLowerCase() === 'standard mode') {
        setProModeUnlocked(false);
        localStorage.removeItem('proModeUnlocked');
        setPlateToSearch(''); // Clear the input
        
        // Show notification
        const notification = document.createElement('div');
        notification.style.cssText = `
            position: fixed;
            top: 80px;
            right: 20px;
            background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
            color: white;
            padding: 1rem 1.5rem;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            z-index: 10000;
            font-weight: 500;
            animation: slideIn 0.3s ease-out;
        `;
        notification.innerHTML = '✓ Standard Mode - Pro Features Hidden';
        document.body.appendChild(notification);
        
        setTimeout(() => {
            notification.style.animation = 'slideOut 0.3s ease-out';
            setTimeout(() => notification.remove(), 300);
        }, 3000);
    }
  };

   const toggleFullScreen = () => {
        if (isFullScreen())
        {
            if (document.documentElement.requestFullScreen){
                document.documentElement.requestFullScreen();
            }
            else if (document.documentElement.mozRequestFullScreen){ /* Firefox */
                document.documentElement.mozRequestFullScreen();
            }
            else if (document.documentElement.webkitRequestFullScreen){   /* Chrome, Safari & Opera */
                document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            }
            else if (document.msRequestFullscreen){ /* IE/Edge */
                document.documentElement.msRequestFullscreen();
            }
        }
        else
        {
            if (document.cancelFullScreen){
                document.cancelFullScreen();
            }
            else if (document.mozCancelFullScreen){ /* Firefox */
                document.mozCancelFullScreen();
            }
            else if (document.webkitCancelFullScreen){   /* Chrome, Safari and Opera */
                document.webkitCancelFullScreen();
            }
            else if (document.msExitFullscreen){ /* IE/Edge */
                document.msExitFullscreen();
            }
        }

   };

   const onAutoScanToggled = () => {
        setModalShow(true);
   }

   const handleSettingsOpen = () => {
        setSettingsModalShow(true);
   }

   const handleSettingsClose = () => {
        setSettingsModalShow(false);
   }

   const handleSoundToggle = () => {
        const newValue = !soundEnabled;
        setSoundEnabled(newValue);
        localStorage.setItem('driveOffSoundEnabled', JSON.stringify(newValue));
        console.log(`🔊 Drive-off sound alerts ${newValue ? 'enabled' : 'disabled'}`);
   }

   const handleAllVehicleSoundToggle = () => {
        const newValue = !allVehicleSoundEnabled;
        setAllVehicleSoundEnabled(newValue);
        localStorage.setItem('allVehicleSoundEnabled', JSON.stringify(newValue));
        console.log(`🔊 All vehicle sound alerts ${newValue ? 'enabled' : 'disabled'}`);
   }

   const handleAutoScanToggleInSettings = async () => {
        if (!isAuthenticated || user['/roles'].length === 0) {
            return;
        }

        const accessToken = await getAccessTokenSilently({
            authorizationParams: {
                  audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
              }
          });

          const userRole = user['/roles'][0];
        const newAutoScanStatus = !isAutoScan;
        const body = {
            "isAutoScanEnabled": newAutoScanStatus,
            "serviceStationOwnerId": "Shan", 
            "groupName": userRole
        }
        const response = await apiClient.postAutoscanSettingForServo(body, accessToken)
        dispatch(setIsAutoScan(newAutoScanStatus));
        console.log(`🔄 Auto Scan ${newAutoScanStatus ? 'enabled' : 'disabled'}`);
   }

   // Test function for audio alert
   const testDriveOffAlert = async () => {
        try {
            console.log('🔊 Testing drive-off alert sound...');
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            
            // Resume audio context if suspended (required for some browsers)
            if (audioContext.state === 'suspended') {
                console.log('🔊 AudioContext suspended, attempting to resume...');
                await audioContext.resume();
            }
            
            console.log('🔊 AudioContext state:', audioContext.state);
            
            const playBeep = (frequency, startTime, duration) => {
                const oscillator = audioContext.createOscillator();
                const gainNode = audioContext.createGain();
                
                oscillator.connect(gainNode);
                gainNode.connect(audioContext.destination);
                
                oscillator.frequency.value = frequency;
                oscillator.type = 'sine';
                
                gainNode.gain.setValueAtTime(0.3, audioContext.currentTime + startTime);
                gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + startTime + duration);
                
                oscillator.start(audioContext.currentTime + startTime);
                oscillator.stop(audioContext.currentTime + startTime + duration);
            };
            
            // Three urgent beeps: high-low-high pattern
            playBeep(1000, 0, 0.15);    // First beep
            playBeep(800, 0.2, 0.15);   // Second beep (lower)
            playBeep(1000, 0.4, 0.3);   // Third beep (longer, urgent)
            
            console.log('✅ Test alert sound played');
        } catch (error) {
            console.error('❌ Error playing test alert:', error);
        }
    };

   

 const onSearchRegoClick = async () => {

    if (!isAuthenticated || user['/roles'].length === 0) {
        return;
     }
        
     const accessToken = await getAccessTokenSilently({
        authorizationParams: {
              audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
          }
      });
    const userRole = user['/roles'][0];
    const pageBatchSize = process.env.REACT_APP_VEHICLE_HISTORY_BATCH_SIZE + 1; //get one more record as we need to show the first one as the latest. Rest will come in line with paging then. 

        const isLoadingRefState = isLoadingRef.current;
        if(!isLoadingRefState) {
            setIsLoading(true);
            const params = {
                plate: plateToSearch, 
                groupName: userRole,
                pageNo: 1,
                pageBatchSize
            };
    
            let result = await apiClient.getVehicleHistoryAsync(params, accessToken)
            setIsLoading(false);
            if (result.length) {
                var selectedVehicle = result.shift(); //get the first item as the selected car. Rest as history. 

                dispatch(setSelectedVehicle(selectedVehicle));
                dispatch(setSelectedVehicleHistory(result));
                dispatch(setShowVehicle(true));
                return;
            }
            
            alert(`No vehicle history found for "${plateToSearch}"`);
            
        }
    
    


    // setModalShow(false);
 }


   const onSetAutoScan = async () => {
    if (!isAuthenticated || user['/roles'].length === 0) {
        return;
     }

     const accessToken = await getAccessTokenSilently({
        authorizationParams: {
              audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
          }
      });
    const userRole = user['/roles'][0];
      const newAutoScanStatus = !isAutoScan;
      const body = {
            "isAutoScanEnabled": newAutoScanStatus,
            "serviceStationOwnerId": "Shan", 
            "groupName": userRole
      }
      const response = await apiClient.postAutoscanSettingForServo(body, accessToken)
      dispatch(setIsAutoScan(newAutoScanStatus));
      setModalShow(false);
   }

   const handleMessageModalClose = () => 
    {
        setModalShow(false);
    }

    const toggleButtonClassNames = classNames({
        'btn':true,
        'btn-sm': true,
        'toggle-btn': true,
        'btn-outline-warning': !isAutoScan,
        'btn-success': isAutoScan
    });
        
   const enableDisableLabelText = isAutoScan ? "Disable" : "Enable";
   
   // Settings Modal
   const settingsModal = (
        <Modal show={settingsModalShow} onHide={() => handleSettingsClose()}
               centered
               size="lg"
        >
            <Modal.Header closeButton style={{borderBottom: '1px solid var(--gray-200)', backgroundColor: '#1E70E0'}}>
                <Modal.Title className="fw-semibold" style={{color: 'white'}}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white" className="me-2" style={{marginBottom: '2px'}}>
                        <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
                    </svg>
                    Settings
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* Reports Section - Pro Mode Only */}
                {proModeUnlocked && (
                    <div className="mb-4 pb-4" style={{borderBottom: '1px solid var(--gray-200)', padding: '2rem 1rem'}}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div>
                                <h6 className="fw-bold mb-1">Activity Reports</h6>
                                <p className="text-muted mb-0 small">View daily, weekly, and monthly summaries</p>
                            </div>
                            <button 
                                type="button" 
                                className="btn btn-primary"
                                onClick={() => {
                                    window.open('/#/reports', '_blank');
                                }}
                            >
                                View Reports
                            </button>
                        </div>
                        <div className=" mt-3 d-flex align-items-center justify-content-between">
                            <div>
                                <h6 className="fw-bold mb-1">Vehicle Detection & Drive-Off Risk Monitoring Dashboard</h6>
                                <p className="text-muted mb-0 small">Interactive dashboard showing peak times, and potential drive-off risks.</p>
                            </div>
                            <button 
                                type="button" 
                                className="btn btn-primary"
                                onClick={() => {
                                    window.open('/#/reportDashboard', '_blank');
                                }}
                            >
                                View Dashboard
                            </button>
                        </div>
                    </div>
                )}

                {/* Drive-Off Alert Sound Setting */}
                <div className="mb-4 pb-4" style={{borderBottom: '1px solid var(--gray-200)' , padding: '2rem 1rem'}}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <h6 className="fw-bold mb-1">Drive-Off Alert Sound</h6>
                            <p className="text-muted mb-0 small">Play urgent alert when drive-off vehicles are detected</p>
                        </div>
                        <div className="form-check form-switch" style={{transform: 'scale(1.3)'}}>
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                id="soundToggle"
                                checked={soundEnabled}
                                onChange={handleSoundToggle}
                                style={{cursor: 'pointer'}}
                            />
                        </div>
                    </div>
                </div>

                {/* All Vehicle Alert Sound Setting */}
                <div className="mb-4 pb-4" style={{borderBottom: '1px solid var(--gray-200)', padding: '2rem 1rem'}}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <h6 className="fw-bold mb-1">All Vehicle Alert Sound</h6>
                            <p className="text-muted mb-0 small">Play short beep when any vehicle is detected</p>
                        </div>
                        <div className="form-check form-switch" style={{transform: 'scale(1.3)'}}>
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                id="allVehicleSoundToggle"
                                checked={allVehicleSoundEnabled}
                                onChange={handleAllVehicleSoundToggle}
                                style={{cursor: 'pointer'}}
                            />
                        </div>
                    </div>
                </div>

                {/* Auto Scan Setting */}
                <div className={proModeUnlocked ? "mb-4 pb-4" : "mb-0"} style={proModeUnlocked ? {borderBottom: '1px solid var(--gray-200)', padding: '2rem 1rem'} : {padding: '2rem 1rem'}}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <h6 className="fw-bold mb-1">Auto Scan</h6>
                            <p className="text-muted mb-0 small">Automatically scan vehicle registrations</p>
                        </div>
                        <div className="form-check form-switch" style={{transform: 'scale(1.3)'}}>
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                id="autoScanToggle"
                                checked={isAutoScan}
                                onChange={handleAutoScanToggleInSettings}
                                style={{cursor: 'pointer'}}
                            />
                        </div>
                    </div>
                </div>

                {/* Test Drive-Off Alert - Pro Mode Only */}
                {proModeUnlocked && (
                    <div className="mb-4 pb-4" style={{borderBottom: '1px solid var(--gray-200)', padding: '2rem 1rem'}}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div>
                                <h6 className="fw-bold mb-1">Test Drive-Off Alert</h6>
                                <p className="text-muted mb-0 small">Test the audio alert system for drive-off notifications</p>
                            </div>
                            <button 
                                type="button" 
                                className="btn btn-outline-primary"
                                onClick={() => testDriveOffAlert()}
                                disabled={!soundEnabled}
                            >
                                Test Alert
                            </button>
                        </div>
                    </div>
                )}

                {/* Software Version - Pro Mode Only */}
                {proModeUnlocked && (
                    <div className="mb-0" style={{padding: '2rem 1rem'}}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div>
                                <h6 className="fw-bold mb-1">Software Version</h6>
                                <p className="text-muted mb-0 small" style={{fontFamily: 'monospace'}}>v{packageJson.version}</p>
                            </div>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer style={{borderTop: '1px solid var(--gray-200)'}}>
                <button 
                    type="button" 
                    className="btn btn-primary"
                    onClick={() => handleSettingsClose()}
                >
                    Done
                </button>
            </Modal.Footer>
        </Modal>
   );
   
   const messageModal = (
    <Modal show={modalShow} onHide={() => handleMessageModalClose() }
           centered
           size="sm"
    >
        <Modal.Header closeButton style={{borderBottom: '1px solid var(--gray-200)'}}>
          <Modal.Title className="fw-semibold">
            {isAutoScan ? "Disable Auto Scan" : "Enable Auto Scan"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p className="mb-0 text-muted">{`Are you sure you want to ${enableDisableLabelText.toLowerCase()} Auto Scan?`}</p>
        </Modal.Body>
        <Modal.Footer style={{borderTop: '1px solid var(--gray-200)'}}>
            <div className="d-flex gap-2 w-100 justify-content-end">
                <button 
                    type="button" 
                    className="btn btn-outline-secondary btn-sm"  
                    onClick={() => handleMessageModalClose()}
                >
                    Cancel
                </button>
                <button 
                    type="button" 
                    className={`btn btn-sm ${isAutoScan ? 'btn-outline-danger' : 'btn-primary'}`}
                    onClick={() => onSetAutoScan()}
                >
                    {isAutoScan ? 'Disable' : 'Enable'}
                </button>
            </div>
        </Modal.Footer>
    </Modal>);


   return (
      <React.Fragment>
        <nav className="navbar navbar-light bg-white border-bottom fixed-top" style={{boxShadow: '0 2px 8px rgba(0,0,0,0.08)', zIndex: 1000, padding: '0.75rem 0'}}>
            <div className="container-fluid px-3 px-md-4">
                {/* Mobile Layout (< 768px): Two rows */}
                <div className="d-md-none w-100">
                    {/* Row 1: Logo/Brand and User Profile - Full width justified */}
                    <div className="d-flex align-items-center justify-content-between w-100 mb-3">
                        {/* Logo and Brand */}
                        <a className="navbar-brand d-flex align-items-center text-decoration-none mb-0 flex-shrink-1" href="/" style={{minWidth: 0}}>
                            <div 
                                className="d-flex align-items-center justify-content-center me-2 flex-shrink-0"
                                style={{
                                    width: '48px', 
                                    height: '48px', 
                                    background: 'linear-gradient(135deg, #1E70E0 0%, #0D47A1 100%)',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 12px rgba(30, 112, 224, 0.25)'
                                }}
                            >
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                    {/* Shield shape */}
                                    <path d="M12 2L20 6V12C20 16.5 16.5 20 12 20C7.5 20 4 16.5 4 12V6L12 2Z" fill="white"/>
                                    {/* Car silhouette */}
                                    <path d="M8 14H16C16.5 14 17 13.5 17 13V11C17 10.5 16.5 10 16 10H8C7.5 10 7 10.5 7 11V13C7 13.5 7.5 14 8 14Z" fill="#1E70E0"/>
                                    <circle cx="9" cy="15" r="1" fill="#1E70E0"/>
                                    <circle cx="15" cy="15" r="1" fill="#1E70E0"/>
                                </svg>
                            </div>
                            <div className="text-start flex-shrink-1" style={{minWidth: 0}}>
                                <div className="fw-bold text-dark text-truncate" style={{fontSize: '18px', lineHeight: '1.2', marginBottom: '2px'}}>Drive Off Shield</div>
                                <div className="text-muted d-none d-sm-block text-truncate" style={{fontSize: '11px', lineHeight: '1', fontWeight: '500'}}>Stop drive offs before they happen</div>
                            </div>
                        </a>

                        {/* User Profile - Right aligned */}
                        <div className="flex-shrink-0 ms-2">
                            <ul className="navbar-nav mb-0">
                                <UserProfile onSettingsClick={handleSettingsOpen} />
                            </ul>
                        </div>
                    </div>

                    {/* Row 2: Search Bar - Full width */}
                    <div className="w-100">
                        <div className="d-flex align-items-stretch gap-2 w-100">
                            <input 
                                type="text" 
                                className="form-control" 
                                onChange={onSearchForRegoChange} 
                                placeholder="Search registration..."
                                value={plateToSearch || ''}
                                style={{
                                    flex: '1 1 auto',
                                    border: '2px solid #e9ecef',
                                    borderRadius: '8px',
                                    padding: '10px 16px',
                                    fontSize: '15px',
                                    transition: 'all 0.2s ease'
                                }}
                                onFocus={(e) => e.target.style.borderColor = '#1E70E0'}
                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                            />
                            <button 
                                type="button" 
                                className="btn btn-primary flex-shrink-0" 
                                onClick={() => onSearchRegoClick()}
                                style={{
                                    padding: '10px 24px',
                                    fontSize: '15px',
                                    fontWeight: '600',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                Search
                            </button>
                        </div>
                    </div>
                </div>

                {/* Desktop Layout (>= 768px): Single row */}
                <div className="d-none d-md-flex align-items-center justify-content-between w-100">
                    {/* Logo and Brand */}
                    <a className="navbar-brand d-flex align-items-center text-decoration-none mb-0" href="/">
                        <div 
                            className="d-flex align-items-center justify-content-center me-3"
                            style={{
                                width: '48px', 
                                height: '48px', 
                                background: 'linear-gradient(135deg, #1E70E0 0%, #0D47A1 100%)',
                                borderRadius: '12px',
                                boxShadow: '0 4px 12px rgba(30, 112, 224, 0.25)'
                            }}
                        >
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                {/* Shield shape */}
                                <path d="M12 2L20 6V12C20 16.5 16.5 20 12 20C7.5 20 4 16.5 4 12V6L12 2Z" fill="white"/>
                                {/* Car silhouette */}
                                <path d="M8 14H16C16.5 14 17 13.5 17 13V11C17 10.5 16.5 10 16 10H8C7.5 10 7 10.5 7 11V13C7 13.5 7.5 14 8 14Z" fill="#1E70E0"/>
                                <circle cx="9" cy="15" r="1" fill="#1E70E0"/>
                                <circle cx="15" cy="15" r="1" fill="#1E70E0"/>
                            </svg>
                        </div>
                        <div className="text-start">
                            <div className="fw-bold text-dark" style={{fontSize: '20px', lineHeight: '1.2', marginBottom: '2px'}}>Drive Off Shield</div>
                            <div className="text-muted" style={{fontSize: '12px', lineHeight: '1', fontWeight: '500'}}>Stop drive offs before they happen</div>
                        </div>
                    </a>

                    {/* Search and User Profile */}
                    <div className="d-flex align-items-center gap-3">
                        <div className="d-flex align-items-center gap-2">
                            <input 
                                type="text" 
                                className="form-control" 
                                onChange={onSearchForRegoChange} 
                                placeholder="Search registration..."
                                value={plateToSearch || ''}
                                style={{
                                    width: '240px',
                                    border: '2px solid #e9ecef',
                                    borderRadius: '8px',
                                    padding: '10px 16px',
                                    fontSize: '15px',
                                    transition: 'all 0.2s ease'
                                }}
                                onFocus={(e) => e.target.style.borderColor = '#1E70E0'}
                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                            />
                            <button 
                                type="button" 
                                className="btn btn-primary" 
                                onClick={() => onSearchRegoClick()}
                                style={{
                                    minWidth: '100px',
                                    padding: '10px 24px',
                                    fontSize: '15px',
                                    fontWeight: '600'
                                }}
                            >
                                Search
                            </button>
                        </div>
                        
                        <ul className="navbar-nav mb-0">
                            <UserProfile onSettingsClick={handleSettingsOpen} />
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
        {messageModal}
        {settingsModal}
        <AlertModal
           show={logoutModalShow} 
           handleOnClick={() => onLogoutModalClick() } 
           headerTitle='Authorisation Pending'
           messageBody='Your user roles have not been assigned yet. Please contact your administrator to request the necessary access.'
           buttonText='Logout'
        />
      </React.Fragment>
    );
}

export default Header;